import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { DetailsList, mergeStyles, PrimaryButton, Stack } from '@fluentui/react';
import { AppContext } from '../contexts/AppContext';
import Loader from '../components/Loader';

const BOLListPage = () => {
    const { getBolList } = useContext(AppContext)
    const [bolList, setBolList] = useState();
    const [isLoading, setIsLoading] = useState(false);

    const columns = [
        { key: 'serialNo', name: 'شماره سریال', fieldName: 'serialNo', minWidth: 100, maxWidth: 200, isResizable: true },
        { key: 'createDate', name: 'تاریخ ایجاد', fieldName: 'createDate', minWidth: 100, maxWidth: 200, isResizable: true },
        { key: 'productType', name: 'کالا', fieldName: 'productType', minWidth: 100, maxWidth: 200, isResizable: true },
    ]

    const myStyles = mergeStyles({
        mainStack: {
            root: {
                // height: '100%',
            }
        }
    })

    const btnGet_Click = async () => {
        setIsLoading(true);
        getBolList().then(result => {
            setBolList(result);
            setIsLoading(false);
        })
    }

    return (
        <Stack styles={myStyles.mainStack}>
            <PrimaryButton text="دریافت لیست بارنامه ها" onClick={btnGet_Click} iconProps={{ iconName: "Info" }} />
            {isLoading ?
                <Loader />
                :
                // bolList && bolList.map(b => <p key={b.id}>{b.serialNo}</p>)
                bolList && <DetailsList items={bolList} columns={columns}/>
            }
        </Stack>
    )
}

export default withRouter(BOLListPage);